import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { HistoryDialog } from 'modules/dialog';
import { Button } from "@blueprintjs/core";
import LetterDetail from './LetterDetail.jsx';
import { ShowIf } from 'components/utils';
import { Text } from 'components/tt-forms/common';
import classnames from 'classnames';

class LetterInformation extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      isOpen: true,
      role: '',
      tinhTrang:''
    }
  }

  componentDidMount() {

    if (this.props.typePage == 'xu-ly')
      this.setState({
        isOpen: false,
      })

  }

  handleClick() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  showHanXuLy() {

    let hanXuLy = '';
    if (this.props.thongTinGiaiQuyetDonId) {

      if (this.props.thongTinGiaiQuyetDonPlus.ngayBatDauKTDX) {

        hanXuLy = this.props.thongTinGiaiQuyetDonPlus.ngayHetHanKTDX;
      } else {

        if (this.props.thongTinGiaiQuyetDonPlus.donViThamTraXacMinhInfo &&
          this.props.thongTinGiaiQuyetDonPlus.donViThamTraXacMinhInfo.coQuanQuanLyId == this.props.userInfo.donViId) {

          if (this.props.parent.loaiDonGiaTri == 'DON_KHIEU_NAI') {

            if (this.props.thongTinGiaiQuyetDonPlus.ngayHetHanSauKhiGiaHanTTXM) {

              hanXuLy = this.props.thongTinGiaiQuyetDonPlus.ngayHetHanSauKhiGiaHanTTXM;
            } else {

              hanXuLy = this.props.thongTinGiaiQuyetDonPlus.ngayHetHanTTXM;
            }
          } else {

            hanXuLy = this.props.thongTinGiaiQuyetDonPlus.ngayHetHanTTXM;
          }
        }

        if (this.props.parent.data.donViXuLyGiaiQuyetInfo &&
          this.props.parent.data.donViXuLyGiaiQuyetInfo.coQuanQuanLyId == this.props.userInfo.donViId) {

          if (this.props.parent.loaiDonGiaTri == 'DON_TO_CAO') {

            if (this.props.thongTinGiaiQuyetDonPlus.ngayHetHanSauKhiGiaHanGiaiQuyet) {

              hanXuLy = this.props.thongTinGiaiQuyetDonPlus.ngayHetHanSauKhiGiaHanGiaiQuyet;
            } else {

              hanXuLy = this.props.thongTinGiaiQuyetDonPlus.ngayHetHanGiaiQuyet;
            }
          } else {

            hanXuLy = this.props.thongTinGiaiQuyetDonPlus.ngayHetHanGiaiQuyet;
          }
        }
      }
    } else {

      hanXuLy = this.props.parent.data.thoiHanXuLyXLD;
    }

    let hanXuLyResult = hanXuLy ? moment(hanXuLy).format('DD/MM/YYYY') : '';
    return hanXuLyResult
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.parent.data.trangThaiDonInfo && nextProps.userInfo) {

      nextProps.parent.data.trangThaiDonInfo.filter(item => {
        return item.donViId == nextProps.userInfo.donViId;
      }).map((child, i) => {
        this.setState({
          tinhTrang: child.trangThaiDonText
        })
      });
    }
  }


  render() {
    return (
      <div className="content-wrap content-gqd background-detail panel-page">
        <ShowIf condition={this.props.checkDonCu === undefined}>
          <div className={classnames({
            'header-redirect background-detail': this.state.isOpen,
            'background-detail header-redirect no-border-bottom': !this.state.isOpen
          })}>
              <div className="row-col">
                <Text
                  className="header-col pl15"
                  label="Mã hồ sơ:"
                  value={this.props.parent.data.maHoSo} />
                <Text
                  className={classnames({
                    'header-col': this.props.parent.ma !== '',
                    'header-col pl15': this.props.parent.ma === '',
                  })}
                  label={this.props.parent.data.donChuyen ? 'Ngày chuyển:' : 'Ngày tiếp nhận:'}
                  value={this.props.parent.ngayTiepNhan ? moment(this.props.parent.ngayTiepNhan).format('DD/MM/YYYY') : ''} />
                <Text
                  className="header-col"
                  label="Trạng thái xử lý:"
                  value={this.state.tinhTrang} />
                <Text
                  className="header-col"
                  label="Hạn xử lý:"
                  value={this.showHanXuLy()} />
                <div className="header-col">
                  <HistoryDialog donId={this.props.donId} ma={this.props.parent.ma}/>
                </div>
                <div className="header-col pl0 pr15">
                  <Button onClick={this.handleClick.bind(this)} className={this.state.isOpen ? "btn-collap active" : "btn-collap"} />
                </div>
              </div>
          </div>
        </ShowIf>
        <div className="wrap-block pl10 pr10 pt10">
          <LetterDetail checkXLDC={this.props.checkXLDC} isOpen={this.state.isOpen} parent={this.props.parent} />
        </div>
      </div>
    )
  }
}

let bindStateToProps = state => {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
  }
}

export default connect(bindStateToProps)(LetterInformation);



// WEBPACK FOOTER //
// ./src/components/modules/letter-information/LetterInformation.jsx